// src/admin/components/Disclosure.jsx
import React, { useState } from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';
import { COLORS, FONT_SANS } from '../../constants/theme.js';

export default function Disclosure({ title, defaultOpen = false, children }) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div style={{ marginBottom: '12px' }}>
      <button
        type="button"
        onClick={() => setOpen(o => !o)}
        style={{
          display: 'inline-flex', alignItems: 'center', gap: '4px',
          background: 'transparent', border: 'none',
          color: COLORS.ink, fontSize: '12px', fontWeight: 600,
          cursor: 'pointer', padding: '4px 0',
          fontFamily: FONT_SANS,
        }}
      >
        {open ? <ChevronDown size={14} /> : <ChevronRight size={14} />}
        {title}
      </button>
      {open && <div style={{ marginTop: '8px' }}>{children}</div>}
    </div>
  );
}
